const API_BASE_URL = (import.meta.env as any).VITE_API_BASE_URL || (import.meta.env as any).NEXT_PUBLIC_API_URL || 'https://hospital-management-api-vtvpllql.fly.dev';
export const USE_MOCK = true;

console.log('🔗 API Configuration:', { API_BASE_URL, USE_MOCK });

const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      console.warn(`❌ API request failed: ${response.status} ${response.statusText} for ${url}`);
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    console.log(`✅ API request successful: ${endpoint}`);
    return data;
  } catch (error) {
    console.warn(`⚠️ API request failed, falling back to mock data:`, error);
    throw error;
  }
};

export const api = {
  health: () => apiRequest('/health'),

  // Patients
  patients: {
    getAll: (search?: string) => {
      const params = search ? `?search=${encodeURIComponent(search)}` : '';
      return apiRequest(`/patients${params}`);
    },
    getById: (id: string) => apiRequest(`/patients/${id}`),
    create: (patient: any) => apiRequest('/patients', {
      method: 'POST',
      body: JSON.stringify(patient),
    }),
    update: (id: string, patient: any) => apiRequest(`/patients/${id}`, {
      method: 'PUT',
      body: JSON.stringify(patient),
    }),
    delete: (id: string) => apiRequest(`/patients/${id}`, {
      method: 'DELETE',
    }),
  },

  // Doctors
  doctors: {
    getAll: (search?: string) => {
      const params = search ? `?search=${encodeURIComponent(search)}` : '';
      return apiRequest(`/doctors${params}`);
    },
    getById: (id: string) => apiRequest(`/doctors/${id}`),
    create: (doctor: any) => apiRequest('/doctors', {
      method: 'POST',
      body: JSON.stringify(doctor),
    }),
    update: (id: string, doctor: any) => apiRequest(`/doctors/${id}`, {
      method: 'PUT',
      body: JSON.stringify(doctor),
    }),
    delete: (id: string) => apiRequest(`/doctors/${id}`, {
      method: 'DELETE',
    }),
  },

  // Appointments
  appointments: {
    getAll: (startDate?: string, endDate?: string) => {
      const params = new URLSearchParams();
      if (startDate) params.append('start_date', startDate);
      if (endDate) params.append('end_date', endDate);
      const queryString = params.toString() ? `?${params.toString()}` : '';
      return apiRequest(`/appointments${queryString}`);
    },
    getById: (id: string) => apiRequest(`/appointments/${id}`),
    create: (appointment: any) => apiRequest('/appointments', {
      method: 'POST',
      body: JSON.stringify(appointment),
    }),
    update: (id: string, appointment: any) => apiRequest(`/appointments/${id}`, {
      method: 'PUT',
      body: JSON.stringify(appointment),
    }),
    delete: (id: string) => apiRequest(`/appointments/${id}`, {
      method: 'DELETE',
    }),
  },
};
